const ghLog = process.env.isSSR ? {} : require("@shanquweb/gh-log")

// 埋点url为key
const urlKey = "https://m.ghzs666.com/"

export const EnterLog = () => {
  if (process.env.isSSR) return
  const entrance = ghLog.getChannel()
  ghLog.WebLog({
    event: "tool_box_page_enter",
    entrance,
    url: urlKey,
    tool_box_id: window.location.href,
    tool_box_name: ""
  })
}

export const PvLog = () => {
  if (process.env.isSSR) return {}
  return ghLog.webPvLog({
    event: "tool_box_page_view",
    url: urlKey,
    tool_box_id: window.location.href,
    tool_box_name: ""
  })
}

export const Log = () => {
  if (process.env.isSSR) return
  EnterLog()
  return PvLog()
}

export const downloadLog = (entrance: string) => {
  if (process.env.isSSR) return {}
  return ghLog.webPvLog({
    event: "mobile_content_home_page_dialog_download_click",
    entrance
  })
}

export const openAppLog = (entrance: string) => {
  if (process.env.isSSR) return {}
  return ghLog.webPvLog({
    event: "mobile_content_home_page_dialog_app_open_click",
    entrance
  })
}
